import styled from 'styled-components'
import { Tooltip, Button } from '@material-ui/core'
import { tokens, primitives } from '../../../assets/tokens'
import React from 'react'

export const ButtonStyled = styled(props => <>
    { props?.tooltip ? (
        <Tooltip title={props.tooltip}>
            <Button {...props} />
        </Tooltip>
    ): (
        <Button {...props} />
    )}
</>)`
    cursor: ${ props => props.disabled ? 'not-allowed' : 'pointer'};
    pointer-events: ${ props => props.disabled ? 'none' : 'auto'};
    // Réplica de ActionButton outlined del Storybook de Velora (neutro; remove = error)
    padding: 10px 14px !important;
    margin-left: 12px !important;
    background: ${props => props.disabled ? tokens.color.background.muted : tokens.color.background.default} !important;
    border: 1.5px solid ${props => props.disabled ? primitives.neutral[200] : props.remove ? primitives.red[700] : primitives.neutral[300]} !important;
    box-sizing: border-box !important;
    border-radius: 8px !important;
    font-family: ${tokens.typography.fontFamily.primary} !important;
    font-weight: 400 !important;
    font-size: 14px !important;
    line-height: 18px !important;
    color: ${props => props.disabled ? primitives.neutral[400] : props.remove ? primitives.red[800] : primitives.neutral[600]} !important;
    height: 40px !important;
    position: ${props => props.isDeleteOfferBtn ? 'absolute' : 'relative'};
    right: ${props => props.isDeleteOfferBtn ? '18px' : 0};
    transition: background-color 0.2s ease, border-color 0.2s ease;
    span{
        color: inherit !important;
    }
    /* Todos los iconos al mismo tamaño y solo con trazo (lucide), en el color del texto */
    svg{
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        margin-right: ${props => props.isDeleteOfferBtn ? 0 : '8px'};
        fill: ${props => props.svgFill ? props.svgFill : 'none'};
    }
    /* El spinner de carga va centrado en el botón, sin el margen de los iconos */
    .MuiCircularProgress-root svg{
        width: auto;
        height: auto;
        margin-right: 0;
    }
    :hover {
        background: ${props => props.remove ? primitives.red[300] : tokens.color.background.muted} !important;
        border-color: ${props => props.remove ? primitives.red[800] : primitives.neutral[400]} !important;
    }
`
